<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Komisi" />
      </div>
      <div id="page-content-wrapper" v-if="!loading">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-2">
              <router-link
                class="
                  btn btn-outline-primary btn-no-outline btn-with-icon-left
                  mt-3
                  btn-lg
                  px-0
                "
                to="/komisi"
              >
                <i class="material-symbols-outlined">arrow_back</i>Kembali
              </router-link>
            </div>
          </div>

          <center>
            <h2 class="mb-5">Generate Komisi</h2>
            <h4 class="font-body text-muted mb-5">
              Pilih Periode untuk Membuat Komisi untuk Dokter dan Petugas
            </h4>
          </center>
          <div class="row">
            <div class="col-md-3 offset-md-3 pr-1">
              <div class="form-group">
                <Select
                  :input="{
                    name: 'id_periode',
                    value: id_periode,
                    options: periods,
                    placeholder: 'Pilih Periode',
                  }"
                  :value="id_periode"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
            </div>
            <div class="col-md-3 pl-1">
              <button
                class="btn btn-secondary btn-with-icon-right btn-block"
                @click="generate"
              >
                GENERATE
                <i class="material-symbols-outlined">chevron_right</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        id="page-content-wrapper"
        v-else
        style="
          height: 100vh;
          width: 100vw;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        "
      >
        <LoadingSpin></LoadingSpin>
        <h4 class="mt-4">Mengenerate Komisi untuk Pegawai..</h4>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import Select from "@/components/Select.vue";
import LoadingSpin from "@/components/LoadingSpin.vue";
// import { HTTP } from "@/config.js";
let periods = [
  {
    label: "Januari 2021",
    value: 1,
  },
];
let handleChangeResult = null;
export default {
  name: "Dashboard",
  components: {
    Navbar,
    Sidebar,
    Select,
    LoadingSpin,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      id_periode: null,
      loading: false,
      periods: periods,
      isError: false,
      handleChangeResult: handleChangeResult,
      errors: [],
    };
  },
  methods: {
    async generate() {
      //console.log(this.id_periode);
      this.loading = true;
      let result = await this.$store.state.HTTP.post(
        "komisi_ringkasan/generate",
        `id_periode=${this.id_periode}&refresh=1`
      );
      if (result.status == "200") {
        //console.log(result);
        this.loading = false;
        this.$router.push(`/komisi`);
      } else {
        this.loading = false;
        this.errors.push(result.status);
      }
    },
    displayNotFoundError() {
      this.isError = true;
      //console.log("error not found");
      setTimeout(() => {
        this.isError = false;
      }, 5000);
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(this[e.target.name]);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    let result = await this.$store.state.HTTP.get(
      `periode?per_page=999999999999`
    );
    //console.log(result);
    this.periods = result.data.data.map((item) => {
      return { label: item.nama, value: item.id };
    });
  },
};
</script>
